import { ReportPeriodEnum, ReportSubjectSubtypeEnum, ReportSubjectTypeEnum, ReportTypeEnum } from './enums';

export const REPORT_SUBJECT_TYPE_TRANSLATE_KEY: {[key in ReportSubjectTypeEnum]?: string } = {
  [ReportSubjectTypeEnum.PRODUCTS]: 'MODULE.PRODUCTS',
  [ReportSubjectTypeEnum.CUSTOMERS]: 'APP.CUSTOMERS',
  [ReportSubjectTypeEnum.VENDORS]: 'TABLE_SUMMARY_BAR.VENDORS',
  [ReportSubjectTypeEnum.EMPLOYEES]: '',
  [ReportSubjectTypeEnum.GENERAL_PRODUCTS]: '',
};

export const REPORT_SUBJECT_TYPE_LIST: {value: ReportSubjectTypeEnum; label: string }[] = [
  { value: ReportSubjectTypeEnum.PRODUCTS, label: REPORT_SUBJECT_TYPE_TRANSLATE_KEY[ReportSubjectTypeEnum.PRODUCTS] },
  { value: ReportSubjectTypeEnum.CUSTOMERS, label: REPORT_SUBJECT_TYPE_TRANSLATE_KEY[ReportSubjectTypeEnum.CUSTOMERS] },
  { value: ReportSubjectTypeEnum.VENDORS, label: REPORT_SUBJECT_TYPE_TRANSLATE_KEY[ReportSubjectTypeEnum.VENDORS] },
];

export const REPORT_SUBJECT_SUBTYPE_LIST: {[key in ReportSubjectTypeEnum]?: {value: ReportSubjectSubtypeEnum; label: string }[]} = {
  [ReportSubjectTypeEnum.PRODUCTS]: [
    { value: ReportSubjectSubtypeEnum.GOODS, label: 'COMMON.GOODS' },
    { value: ReportSubjectSubtypeEnum.SERVICES, label: 'APP.SERVICES' },
    { value: ReportSubjectSubtypeEnum.DIGITAL_PRODUCTS, label: 'APP.DIGITAL_PRODUCTS' },
  ],
  [ReportSubjectTypeEnum.CUSTOMERS]: [
    { value: ReportSubjectSubtypeEnum.PRIVATE, label: 'APP.PRIVATE' },
    { value: ReportSubjectSubtypeEnum.CORPORATE, label: 'APP.CORPORATE' },
    { value: ReportSubjectSubtypeEnum.ALL, label: 'REPORTING_PERIODS.ALL' },
  ],
  [ReportSubjectTypeEnum.VENDORS]: [
    { value: ReportSubjectSubtypeEnum.PRIVATE, label: 'APP.PRIVATE' },
    { value: ReportSubjectSubtypeEnum.CORPORATE, label: 'APP.CORPORATE' },
    { value: ReportSubjectSubtypeEnum.ALL, label: 'REPORTING_PERIODS.ALL' },
  ],
};

export const REPORT_TYPE_LIST: {[key in ReportSubjectTypeEnum]?: {value: ReportTypeEnum; label: string }[]} = {
  [ReportSubjectTypeEnum.PRODUCTS]: [
    { value: ReportTypeEnum.REVENUE, label: 'REPORTS.PRODUCTS_BY_REVENUE' },
    { value: ReportTypeEnum.SALES_AVG_PRICE, label: 'REPORTS.AVERAGE_PRICE_SALES' },
    { value: ReportTypeEnum.PURCHASE_AVG_PRICE, label: 'REPORTS.AVERAGE_PRICE_PURCHASE' },
  ],
  [ReportSubjectTypeEnum.CUSTOMERS]: [
    { value: ReportTypeEnum.REVENUE, label: 'REPORTS.CUSTOMERS_BY_REVENUE' },
  ],
  [ReportSubjectTypeEnum.VENDORS]: [
    { value: ReportTypeEnum.EXPENSES, label: 'REPORTS.VENDORS_BY_EXPENSES' },
  ]
};

export const REPORT_PERIODS_LIST: {value: ReportPeriodEnum; label: string }[] = [
  { value: ReportPeriodEnum.YEAR, label: 'FORM.YEAR' },
  { value: ReportPeriodEnum.QUARTER, label: 'FORM.QUARTER' },
  { value: ReportPeriodEnum.MONTH, label: 'FORM.MONTH' },
  { value: ReportPeriodEnum.USER_DEFINED, label: 'COMMON.USER_DEFINED_PERIOD' },
];

export const QUARTERS_LIST: {value: number; label: string}[] = [
  { value: 1, label: 'RANGES.JAN_MAR_Q' },
  { value: 2, label: 'RANGES.APR_JUN_Q' },
  { value: 3, label: 'RANGES.JUL_SEP_Q' },
  { value: 4, label: 'RANGES.OCT_DEC_Q' },
];

export const MONTHS_LIST: {value: number; label: string}[] = [
  { value: 1, label: 'MONTHS.JAN' },
  { value: 2, label: 'MONTHS.FEB' },
  { value: 3, label: 'MONTHS.MAR' },
  { value: 4, label: 'MONTHS.APR' },
  { value: 5, label: 'MONTHS.MAY' },
  { value: 6, label: 'MONTHS.JUN' },
  { value: 7, label: 'MONTHS.JUL' },
  { value: 8, label: 'MONTHS.AUG' },
  { value: 9, label: 'MONTHS.SEP' },
  { value: 10, label: 'MONTHS.OCT' },
  { value: 11, label: 'MONTHS.NOV' },
  { value: 12, label: 'MONTHS.DEC' },
];

